import { connect } from "react-redux";
import OrderFetchErrorPage from "../components/_OrderFetchErrorPage";

const mapStateToProps = ({ Misc }) => ({
    language: Misc.language.language,
    store: Misc.store.store
});

const mapDispatchToProps = dispatch => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderFetchErrorPage);



// WEBPACK FOOTER //
// ./src/views/Order/containers/_OrderFetchErrorPage.js